import i18n from 'i18n';
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { FaIdCardAlt } from 'react-icons/fa';
import { formatName, translateGender } from 'utils/AuxiliarFunctions';
import { fixTimezoneOffset } from 'utils/dateFunctions';
import { useUserContext } from 'store';
import { isEmpty } from 'lodash';
import { EmergencyAccess, OrganizationAccess } from '../Modals';
import './Results.css';

export function FindPatient({ patient, organization }) {
  const [user] = useUserContext();
  const [openModalEmergency, setOpenModalEmergency] = useState(false);
  const [openModalOrganization, setOpenModalOrganization] = useState(false);
  const [preSelectOrganization, setPreSelectOrganization] = useState({});

  const isOpenModalOrganization = (childdata) => {
    setOpenModalOrganization(childdata);
  };

  return (
    <div>
      {!isEmpty(patient) && (
        <div className="br-list" role="list">
          <div className="align-items-center br-item py-4" role="listitem">
            <div className="row align-items-center">
              <div className="col-auto ">
                <FaIdCardAlt className="clipboard-icon" />
              </div>

              <div className="col">
                <div className="name-patient">
                  <h3 className="findPatient-text">
                    {formatName(patient.name)}
                  </h3>
                </div>

                <div className="row responsive">
                  <div className="col-auto dateOfBirth">
                    Data de Nascimento:{' '}
                    <b className="findPatient-text">
                      {patient?.birthDate?.length
                        ? fixTimezoneOffset(
                            new Date(patient.birthDate),
                          ).toLocaleDateString(i18n.language)
                        : 'Não encontrado'}
                    </b>
                  </div>

                  <div className="col gender">
                    Gênero:{' '}
                    <b className="findPatient-text">
                      {translateGender(patient.gender)}
                    </b>
                  </div>

                  <div className="col-auto emergency">
                    <button
                      onClick={() => setOpenModalEmergency(true)}
                      className="br-button danger small m-2 filtrar align respoEmergency"
                      type="button"
                    >
                      Acesso de emergência
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <span className="br-divider" />

          <div className="align-items-center br-item py-4" role="listitem">
            <div className="row align-items-center">
              <div className="col-auto" />
              <div className="col" />
              <div className="col-auto">
                {(() => {
                  // ==============================
                  // 1. VERIFICA CONSENTIMENTO (PERMISSÃO)
                  // ==============================
                  const hasPermission = organization?.some((orgElement) =>
                    user.userData.rolesPerOrganization.some(
                      (rolesElement) => rolesElement.id === orgElement.cnes,
                    ),
                  );

                  // ==============================
                  // 2. SEM CONSENTIMENTO → MENSAGEM
                  // ==============================
                  if (!hasPermission) {
                    return (
                      <div className="br-message info p-4">
                        <p style={{ fontSize: 'var(--font-size-scale-up-02)' }}>
                          <b>
                            Informação sobre dados de atendimento do Paciente
                          </b>
                          <br />
                          Os registros deste atendimento não estão disponíveis
                          para visualização porque o paciente revogou o
                          consentimento (LGPD).
                        </p>
                      </div>
                    );
                  }

                  // ==============================
                  // 3. COM CONSENTIMENTO → MOSTRA TODOS OS BOTÕES
                  // ==============================
                  return organization?.map((orgElement, index) => {
                    const disabled = !user.userData.rolesPerOrganization.some(
                      (rolesElement) => rolesElement.id === orgElement.cnes,
                    );

                    return (
                      <button
                        key={`organizationButton-${index}`}
                        disabled={disabled}
                        onClick={() => {
                          setOpenModalOrganization(true);
                          setPreSelectOrganization(orgElement);
                        }}
                        className="resultsButton br-button primary small m-2 filtrar align"
                        type="button"
                      >
                        {orgElement.name}
                      </button>
                    );
                  });
                })()}
              </div>
            </div>
          </div>

          <span className="br-divider md my-3" />
        </div>
      )}

      {openModalOrganization && (
        <OrganizationAccess
          openModalEmergency={setOpenModalEmergency}
          organization={organization}
          isOpen={isOpenModalOrganization}
          patient={patient}
          preSelect={preSelectOrganization}
        />
      )}

      {openModalEmergency && (
        <EmergencyAccess
          setIsOpen={setOpenModalEmergency}
          isOpen={openModalEmergency}
          patient={patient}
        />
      )}
    </div>
  );
}

FindPatient.propTypes = {
  patient: PropTypes.element.isRequired,
  organization: PropTypes.element.isRequired,
};
